<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
// import echarts from 'echarts'
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";
// import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "350px",
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData);
    },
    setOptions({ legendData, lineData } = {}) {
      this.chart.setOption({
        title: {
          text: "",
        },
        legend: {
          orient: "horizontal",
          left: "left"
        },
        radar: {
          // shape: 'circle',
          indicator: [
            { name: "医疗费用", max: 200 },
            { name: "医技费用", max: 200 },
            { name: "护理费用", max: 200 },
            { name: "管理费用", max: 200 }, 
            { name: "耗材费用", max: 200 }
          ],
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: [
              {
                value: [120, 154, 130, 100, 139, 150],
                name: "亏损组",
              },
              {
                value: [100, 160, 100, 100, 108, 100],
                name: "盈余组",
              },
              {
                value: [141, 119, 136, 120, 108, 116],
                name: "标杆组",
              },
            ],
          },
        ],
      });
    },
  },
};
</script>
